/** Whether the server answers this search (store.customerPatterns): two or more
 *  characters with a letter, or three or more digits. */
export function searchable(q: string): boolean {
  const s = q.trim()
  if ([...s].length < 2) return false
  if (/\p{L}/u.test(s)) return true
  return s.replace(/\D/g, '').length >= 3
}

/** A mobile shown with its last four digits only, in a list of matches. */
export function shortPhone(phone: string | undefined): string {
  if (!phone) return ''
  return phone.length > 4 ? `•••${phone.slice(-4)}` : phone
}
